import React from 'react'
import clsx from 'clsx'

import TrackTitle from '../../TrackTitle/TrackTitle'
import ChannellTitle from '../../ChannelTitle/ChannelTitle'

const PlayListItem = ({
    episode,
    active,
    setEpisode,
    dragStartHandler,
    dragEndHandler,
    dragOverHandler
}) => {

    const episodeHandler = () => {
        if (!active) {
            setEpisode(episode)
        }
    }

    return (
        <li className={
            clsx("playlist-item", {
                "active": active
            })
        }
            onClick={episodeHandler}
            draggable
            onDragEnd={(event) => dragStartHandler(event, episode)}
            onDragStart={dragEndHandler}
            onDragOver={(event) => dragOverHandler(event, episode)}
        >
            <figure>
                <img width={35} src={episode.thumbnail} alt={episode.title} />
            </figure>
            <div className="playlist-content">
                <TrackTitle
                    title={episode.title}
                />
                <ChannellTitle channelName={episode.channel.name} />
            </div>
        </li>
    )
}

export default PlayListItem
